import Result from "@/core/common/Result";
import { IDesativarVoucherGateway } from "../ports/DesativarVoucherGateway";
import { inject, injectable } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import "reflect-metadata";

@injectable()
export class DesativarVoucherGatewayAdapter
  implements IDesativarVoucherGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  client!: HttpClient;

  async desativarVoucher(voucherId: string): Promise<Result<void>> {
    try {
      const response = await this.client.post<IDefaultContabilResponse<void>>({
        url: `/v1/contabil/voucher/${voucherId}/desativar-usuario`
      });

      if (response.statusCode !== 200 || response.body?.code !== 200)
        return Result.fail("Não foi possível cancelar o voucher");

      return Result.ok();
    } catch (_e) {
      return Result.fail("Erro inesperado ao cancelar o voucher");
    }
  }
}
